/* global Blockly */
import React from 'react';
import { _defineHelpUrlandToolTip } from '../../helpers/index.js'

// NOSONAR: `block` is a Blockly toolbox-XML pseudo-element, not a real DOM
// element. `colour` is a valid Blockly toolbox attribute.
const ControlsIf = function () {
    const name = "controls_if";
    ControlsIf.blockName = name;

    _defineHelpUrlandToolTip(name, Blockly.BASE_HELP_URL + "#logic", "if statement for conditional logic");

    return (
        <block type={name} colour="#d9d9d9"></block> /* NOSONAR */
    );
};

export default ControlsIf;
